import React from 'react';
import * as actGratuity from 'actions/library/gratuity';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import { isDirty } from 'redux-form';
import { askConfirmAction } from 'actions/confirm-action';
import * as actOutletPage from 'actions/outletPages/list';
import Pusher from 'pusher-js';
import {
  PUSHER_APP_KEY,
  INVENTORY_BUSINESS_PUSHER_CHANNEL,
  INVENTORY_CLONE_OUTLET_PUSHER_EVENT,
} from 'api/constants';
import styles from './List.css';

class List extends React.Component {
  componentDidMount() {
    const { businessId } = this.props;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    this.channel = pusher.subscribe(
      INVENTORY_BUSINESS_PUSHER_CHANNEL(businessId)
    );
  }

  componentDidUpdate() {
    const { dispatch } = this.props;
    if (this.channel) {
      this.channel.unbind();
    }
    this.channel.bind(INVENTORY_CLONE_OUTLET_PUSHER_EVENT, data => {
      dispatch(actOutletPage.checkCloningOutletOnProgress(data));
    });
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind();
    }
  }

  render() {
    const { gratuities, gratuityDetail } = this.props;

    return (
      gratuities.length > 0 && (
        <div className={styles.wrapper}>
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles.name}>Name</th>
                <th className={styles.amount}>Amount</th>
              </tr>
            </thead>
          </table>
          <div
            className={`${
              styles['table-content-wrapper']
            } gratuity-table-content-wrapper`}
          >
            <InfiniteScroll
              pageStart={1}
              loadMore={this._onReachBottom}
              hasMore={this._hasMore()}
              useWindow={false}
              threshold={10}
              initialLoad={false}
            >
              <table className={`${styles['table-content']}`}>
                <tbody>
                  {gratuities.length === 0 && (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center' }}>
                        No data to display
                      </td>
                    </tr>
                  )}
                  {gratuities.length > 0 &&
                    gratuities.map(gratuity => {
                      return (
                        <tr
                          key={gratuity.id}
                          className={`${
                            gratuityDetail && gratuity.id === gratuityDetail.id
                              ? styles.selected
                              : ''
                          }`}
                          onClick={() => this._onClickRow(gratuity)}
                        >
                          <td className={styles.name}>{gratuity.name}</td>
                          <td className={styles.amount}>{gratuity.amount}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      )
    );
  }

  _onClickRow = gratuity => {
    const { isDirtyGratuity } = this.props;
    if (isDirtyGratuity) {
      this.props.dispatch(askConfirmAction(actGratuity.onClickRow(gratuity)));
    } else {
      this.props.dispatch(actGratuity.onClickRow(gratuity));
    }
  };

  _onReachBottom = () => {
    const { dispatch, currentPage, gratuities } = this.props;
    dispatch(
      actGratuity.gratuitiesRequest({ page: currentPage + 1 }, gratuities)
    );
  };

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };
}

function mapStateToProps(state) {
  const {
    gratuities,
    gratuityDetail,
    currentPage,
    totalPage,
  } = state.library.gratuity;
  return {
    gratuities,
    gratuityDetail,
    currentPage,
    totalPage,
    isDirtyGratuity: isDirty('gratuity')(state),
    businessId: state.moka.user.business.id,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

List.propTypes = {
  dispatch: PropTypes.func,
  gratuities: PropTypes.array,
  gratuityDetail: PropTypes.object,
  currentPage: PropTypes.number,
  totalPage: PropTypes.number,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);
